import { API_ENDPOINT } from './config';

export const urlsFriVia = {
  quizzes: `${API_ENDPOINT}/quizzes`,
  quizDetail: (id) => `${API_ENDPOINT}/quizzes/${id}`,
  // Quiz questions
  quizQuestions: `${API_ENDPOINT}/quiz-questions`,
  quizQuestionDetail: (id) => `${API_ENDPOINT}/quiz-questions/${id}`,
  // Student answers
  quizStudentAnswers: `${API_ENDPOINT}/quiz-student-answers`,
  quizStudentAnswersAggregated: `${API_ENDPOINT}/quiz-student-answers/aggregated`,
  quizStudentAnswerDetail: (id) => `${API_ENDPOINT}/quiz-student-answers/${id}`,
  // Quiz runs
  quizRuns: `${API_ENDPOINT}/quiz-runs`,
  quizRunDetail: (id) => `${API_ENDPOINT}/quiz-runs/${id}`,
};

export const routesFriVia = {
  cmsQuizzes: '/cms/quizzes',
  cmsQuizzesEdit: '/cms/quizzes/edit',
  cmsQuizzesCreate: '/cms/quizzes/create',
  cmsStudentQuizAnswers: '/cms/quizzes/answers',
  // Questions pages
  cmsQuizQuestionsCreate: '/cms/quizzes/questions/create',
  cmsQuizQuestionsEdit: '/cms/quizzes/questions/edit',
  // CMS question answer page
  cmsQuizQuestionAnswer: '/cms/quizzes/questions/answer',
  // CMS question preview page
  cmsQuizQuestionPreview: '/cms/quizzes/questions/preview',
  // CMS question QR page
  cmsQuizQuestionQR: '/cms/quizzes/questions/qr',
  // CMS quiz aggregated results page
  cmsQuizResults: '/cms/quizzes/results',
  // CMS quiz question aggregated results page
  cmsQuizQuestionResults: '/cms/questions/results',
  // NEW: My answers overview page
  cmsMyQuizAnswers: '/cms/quizzes/my-answers',
};
